module.exports = require("@swa-ui/encryption");